import React from 'react';

import { AlertCircle, CheckCircle } from 'lucide-react';

import TamanLogo from '../../../assets/TamanLogo.svg';

interface Step4ThankYouProps {
  acceptSuccess: boolean;
  acceptError: string;
}

export const Step4ThankYou: React.FC<Step4ThankYouProps> = ({ acceptSuccess, acceptError }) => {
  return (
    <div className="flex flex-col items-center text-center gap-2">
      <p className="text-white/70 text-2xl md:text-3xl font-light tracking-wide mb-1.5">Welcome to</p>

      <img src={TamanLogo} alt="TAMAN" className="h-11 max-w-[250px] mb-4 md:mb-5 select-none" />

      <p className="text-greyP2 text-md md:text-lg leading-6 max-w-[340px]">
        Thank you for completing your profile.
        <br />
        You're all set to start using TAMAN.
      </p>

      {acceptSuccess && (
        <div className="mt-4 w-full flex items-start gap-2.5 rounded-lg px-3 py-2.5 bg-green01/10 border border-green01/30">
          <CheckCircle size={16} className="text-green01 shrink-0 mt-0.5" />
          <p className="text-white text-xs text-left">
            Your invitation has been accepted successfully! Redirecting to home...
          </p>
        </div>
      )}

      {acceptError && (
        <div className="mt-4 w-full flex items-start gap-2.5 rounded-lg px-3 py-2.5 bg-[#FF8A00]/10 border border-[#FF8A00]/30">
          <AlertCircle size={16} className="text-[#FF8A00] shrink-0 mt-0.5" />
          <p className="text-white text-xs text-left">{acceptError}</p>
        </div>
      )}
    </div>
  );
};
